import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import { components, contentfulModels, contentfulUtils } from '@glowforge/ui-common';

import './subscriptions-toggle.less';

// TODO: This should eventually come from ui-common?
const PremiumIcon = require('./premium-gem-yellow.svg');

const { Checkbox } = components;
const { stringSubstitution } = contentfulUtils;
const { pageStringsPropType } = contentfulModels;

/**
 * Control for making a user a subscription member or not.
 */
const SubscriptionsToggle = (props) => {
  if (!props.isSubscriber) {
    return null;
  }

  const {
    addedUsers,
    totalUsers,
    isSecondaryMember,
  } = props;

  const description = stringSubstitution(
    props.pageStrings['settings-users-seats-left-message'],
    { remaining: (totalUsers - addedUsers.length), total: totalUsers },
  );
  const isDisabled = addedUsers.length >= totalUsers && !isSecondaryMember;

  const renderCheckbox = field => (
    (<Checkbox
      {...field.input}
      disabled={isDisabled}
      label={description}
      className='checkbox' />)
  );

  return (
    <div className='SubscriptionsToggle'>
      <Field name='subscriber' component={renderCheckbox} />
      <PremiumIcon className='premiumIcon' />
    </div>
  );
  // TODO: above needs the (?) button to open help docs?
};

SubscriptionsToggle.propTypes = {
  isSubscriber: PropTypes.bool,
  isSecondaryMember: PropTypes.bool,
  addedUsers: PropTypes.array, // eslint-disable-line
  totalUsers: PropTypes.number,
  pageStrings: pageStringsPropType.isRequired,
};

SubscriptionsToggle.defaultProps = {
  isSubscriber: false,
  isSecondaryMember: false,
  addedUsers: [],
  totalUsers: 0,
};

export default SubscriptionsToggle;



// WEBPACK FOOTER //
// ./app/components/settings/subscriptions-toggle.jsx